import "./Hero.css";

// images
import Parachute from "./images/parachute.webp";
import Ball from "./images/ball.webp";
import Target from "./images/target.webp";
import Notebook from "./images/notebook.webp";
import Backpack from "./images/backpack.webp";
import Yash from "./images/yash.webp";
import Yashika from "./images/yashika.webp";


const Hero = () => {

    return (

        <div className="hero-main" >

            <div className="hero-sub" >


                <h2 className="hero-main-heading" >Putting your <span >child's</span> Future <br /> in great motion</h2>

                <div className="hero-checks" >
                    <p><i className="fa-solid fa-check"></i> Joyful Learning</p>
                    <p><i className="fa-solid fa-check"></i> Independent Growth</p>
                    <p><i className="fa-solid fa-check"></i> Holistic Development</p>
                </div>

                <button className="start-btn" onClick={() => window.open("https://api.whatsapp.com/send?phone=919246182801&text=" + encodeURIComponent("Hello, I want to enquire for admissions \uD83D\uDCDA"), "_blank")} >Enroll Now <i className="fa-solid fa-arrow-up"></i></button>

                {/* <p className="hero-tagline" >We just don't give our students only <br />lecture but real life experiences.</p> */}

                <img className="notebook-hero" src={Notebook} alt="boy" />

                {/* Absolute objects */}
                <img src={Parachute} alt="parachute" className="parachute-float" />

                <img src={Ball} alt="ball" className="ball-float" />

                <img className="girl-hero" src={Yashika} alt="boy" />
                <img className="bag-hero" src={Backpack} alt="boy" />


                <img className="boy-hero" src={Yash} alt="boy" />
                <img className="target-hero" src={Target} alt="boy" />



            </div>

        </div>

    )
}

export default Hero;